<template>
  <div>
    <!--公司简介-->
    <div class="bg_white companyback">
      <div class="container_box cmp_box">
        <div class="row">
          <div class="col-md-3">
            <div class="img_box">
              <img :src="info.companyLogo">
            </div>
          </div>
          <div class="col-md-9">
            <div class="title">{{info.companyName}}</div>
            <p class="introduce">{{info.companySign}}</p>
            <p class="inter">{{info.officialWeb}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 首页主要内容区 -->
    <div class="container_box  bg_white" style="margin-bottom:40px;">
      <div class="cpm_detail_box">
        <div class="home_main content-main clearfix content-main1">
          <div class="home_item_title clearfix">
            <div class="fl">
              <span class="name lang_corporation1">公司介绍</span>
              <span class="name_e media_display">&nbsp;&nbsp;COMPANY INTRODUCTION</span>
            </div>
          </div>
          <div v-if="comImglist.length==0&&info.descriot==''" class="nothing">
            <img src="../assets/images/nothing.png" alt="">
            <div>暂无公司介绍</div>
          </div>
          <div class="home_item_info mgt10">
            {{info.descriot}}
          </div>
          <div class="swiper-container swiper-container1" v-if="comImglist!=''">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in comImglist" v-bind:style="{backgroundImage:'url(' +item+ ')'}"></div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
            <!-- Add Arrows -->
            <div class="swiper-button-prev swiper-button-prev1"></div>
            <div class="swiper-button-next swiper-button-next1"></div>
          </div>
        </div>

        <div class="home_main content-main clearfix content-main5">
          <div class="home_item_title clearfix">
            <div class="fl">
              <span class="name lang_corporation2">公司产品</span>
              <span class="name_e media_display">&nbsp;&nbsp;COMPANY PRODUCTS</span>
            </div>
          </div>
          <div v-if="productList.length==0" class="nothing">
            <img src="../assets/images/nothing.png" alt="">
            <div>暂无公司产品介绍</div>
          </div>
          <div class="swiper-container swiper-container4 media_display" v-if="productList!=''">
            <div class="swiper-wrapper swiper-wrapper4">
              <div class="swiper-slide" v-for='(item,index) in productList' @click="toOpenproduct(item)">
                <img :src="imgoneShow[index]">
                <div>{{item.title}}</div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination swiper-pagination4"></div>
          </div>
          <div class="swiper-container swiper_phone1 media_display2" v-if="productList!=''">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for='(item,index) in productList'>
                <img :src="imgoneShow[index]">
                <div class="ac mgt20">{{item.title}}</div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="home_main content-main content-main3 clearfix">
          <div class="home_item_title clearfix">
            <div class="fl">
              <span class="name lang_corporation3">公司荣誉</span>
              <span class="name_e media_display">&nbsp;&nbsp;COMPANY HONORS</span>
            </div>
          </div>
          <div v-if="houronList.length==0" class="nothing">
            <img src="../assets/images/nothing.png" alt="">
            <div>暂无公司荣誉介绍</div>
          </div>
          <div class="swiper-container swiper-container2 media_display" v-if="houronList!=''">
            <div class="swiper-wrapper swiper-wrapper2">
              <div class="swiper-slide swiper-slide2" v-for="(item,index) in houronList">
                <div v-bind:style="{backgroundImage:'url(' +item.imgs+ ')'}"></div>
                <p>{{item.title}}</p>
              </div>
            </div>
            <div class="swiper-button-prev swiper-button-prev2">
              <img src="../assets/images/left.png">
            </div>
            <div class="swiper-button-next swiper-button-next2">
              <img src="../assets/images/right.png">
            </div>
          </div>
          <div class="swiper-container swiper_phone2 media_display2" v-if="houronList!=''">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in houronList">
                <div v-bind:style="{backgroundImage:'url(' +imgoneShow2[index]+ ')'}"></div>
                <p class="ac mgt20">{{item.title}}</p>
              </div>
            </div>
            <!-- <div class="swiper-pagination"></div> -->
          </div>
        </div>

        <!-- <div class="home_main content-main content-main4 clearfix">
          <div class="home_item_title clearfix">
            <div class="fl">
              <span class="name lang_corporation4">公司对接</span>
              <span class="name_e media_display">&nbsp;&nbsp;COMPANY ABUTMENT</span>
            </div>
          </div>
          <div v-if="dockList.length==0" class="nothing">
            <img src="../assets/images/nothing.png" alt="">
            <div>暂无公司对接</div>
          </div>
          <div class="home_item_list">
            <div class="item_list_one">
              <div :href="'../wisdom/tech-exchange-detail.html?id='+item.id">
                <div class="row">
                  <div class="col-md-9 col-xs-12 content_text ellipsis1">{{item.title}}</div>
                  <div class="col-md-3 col-xs-12 time">{{item.createTime}}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <bottom-footer></bottom-footer> -->

    <!-- 企业产品详情 -->
    <div class="productDetail" >
      <div class="detail">
        <img src="../assets/images/close3.png" class="close" @click="closeDetail">
        <div class="swiper-container swiper-container6">
          <div class="swiper-wrapper swiper-wrapper6">
            <div class="swiper-slide swiper-slide6" v-for ="(res,index) in imgProduct">
              <img :src ="res">
            </div>   
          </div>                        
          <div class="swiper-button-prev swiper-button-prev3">
            <img src="../assets/images/left.png">
          </div>
          <div class="swiper-button-next swiper-button-next3">
            <img src="../assets/images/right.png">
          </div>            
        </div>
        <div class="name">{{productDetail.title}}</div>
        <div class="nameDetail">
          {{productDetail.content}}
        </div>
      </div>
    </div> 
  </div>
</template>
<script>
export default {
  data(){
    return{
      id:'',
      info:{},
      comImglist:[],
      productList:[],
      imgoneShow:[],
      houronList:[],
      imgoneShow2:[],
      dockList:[],
      imgProduct:[],
      productDetail:{},
    }
  },
  methods: {
    getDetail(){
      this.$http.get(this,'/useCenter/companyCenter/'+this.id).then(res=>{
        if(res){
          this.info = res.data.info;          
          if(this.info.imgs!=undefined){
            var comImglist = this.info.imgs.split(",");
            this.comImglist=comImglist.slice(0,comImglist.length);
          }           
          this.productList = res.data.products;
          this.imgoneShow =[];
          for(var i=0;i<this.productList.length;i++){
            var imgs;
            imgs= this.productList[i].imgs.split(",");
            var imgone= imgs[0];
            this.imgoneShow.push(imgone);
          }            
          this.houronList = res.data.honors;
          this.imgoneShow2 =[];
          for(var i=0;i<this.houronList.length;i++){
            var imgs2= this.houronList[i].imgs.split(",");
            var imgone2= imgs2[0];
            this.imgoneShow2.push(imgone2);              
          }
          this.dockList = res.data.docks;
          this.$nextTick(function () {
            this.getSwiper1();
            this.getSwiper2();
            this.getSwiper3();
            this.getSwiperPhone1();
            this.getSwiperPhone2();
          })
        }
      })
    },
    //公司介绍
    getSwiper1:function(){
      //轮播
      var swiper1 = new Swiper('.content-main1 .swiper-container', {
          loop: true,
          autoplay: 3000,
          grabCursor: true,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          prevButton:'.swiper-button-prev',
          nextButton:'.swiper-button-next',
      });
    },
    getSwiper2:function(){
      var swiper3 = new Swiper('.content-main5 .swiper-container4', {
        slidesPerView: 4,
        slidesPerColumn: 1,
        spaceBetween: 20,
        pagination: '.swiper-pagination',
      });
    },
    // 手机屏,公司产品
    getSwiperPhone1:function(){
        var swiperPhone = new Swiper('.content-main5 .swiper_phone1', {
        loop: true,
        autoplay: 3000,
        touchRatio : 0.5,
        pagination : '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction : false,
      });                               
    },
    //公司荣誉轮播
    getSwiper3:function(){
      var swiper2 = new Swiper('.content-main3 .swiper-container2', {
      spaceBetween: 20,
      slidesPerView : 'auto',
      loopedSlides :6,
      prevButton:'.swiper-button-prev',
      nextButton:'.swiper-button-next',
      });
    },
      // 手机屏,公司荣誉
    getSwiperPhone2:function(){
        var swiperPhone2 = new Swiper('.content-main3 .swiper_phone2', {
          loop: true,
          autoplay: 3000,
          touchRatio : 0.5,
          pagination : '.swiper-pagination',
       });                               
     },
    getSwiper4:function(){
         var swiper4 = new Swiper('.detail .swiper-container', {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesPerView : 'auto',
            prevButton:'.swiper-button-prev',
            nextButton:'.swiper-button-next',
        });                               
      },    
    closeDetail:function(){
        $(".productDetail").hide();
      },
    toOpenproduct:function(item){
        $(".productDetail").show();
            var imgProduct = item.imgs.split(",");
            this.imgProduct=imgProduct;
            this.productDetail = item;
            this.$nextTick(function () {
               this.getSwiper4();
        })
      }   
    },
    created:function() {
      this.id =this.$route.query.id;
      this.getDetail();
    },
};
</script>
<style scoped>
.swiper-container2 {
  height: 190px;
  margin: 40px auto;
  padding: 0px 200px;
}
.swiper-container.swiper-container1 {
  height: 390px;
}
.swiper-container1 .swiper-slide {
  background-position: center;
  background-size: cover;
  margin-top: 0px;
}
.swiper-wrapper2 {
  margin: 0 100px;
  height: 100%;
  width: 100%;
  margin-left: -80px;
  padding-left: 0px;
}
.swiper-slide2 {
  width: 240px !important;
  height: 190px;
  /* padding-left:0px; */
  overflow: hidden;
  margin-right: 20px;
}
.swiper-button-next.swiper-button-next1 {
  top: 37%;
  background-image: url(../assets/images/right.png);
  width: 33px;
  height: 63px;
  background-size: 100% 100%;
  z-index: 100;
}
.swiper-button-prev.swiper-button-prev1 {
  top: 37%;
  left: 20px;
  background-image: url(../assets/images/left.png);
  width: 33px;
  height: 63px;
  z-index: 100;
  background-size: 100% 100%;
}
.swiper-pagination-bullet-active {
  background: #234ea0;
}
@media (min-width: 768px) {
.swiper-container.swiper-container1 {
    width: 680px;
    margin-top: 60px;
}
  .swiper-container1 .swiper-slide {
    width: 480px;
    height: 330px;
  }
  .swiper-container2 {
    width: 1000px;
  }
}
@media (max-width: 767px) {
  .swiper-container.swiper-container1 {
    width: 300px;
    height: 145px;
    margin-top: 10px;
  }
  .swiper-container1 .swiper-slide {
    width: 100%;
    height: 145px;
  }
  .swiper_phone1 {
    width: 300px;
    height: 200px;
    margin-top: 20px;
  }
  .swiper_phone1 .swiper-slide {
    width: 300px;
    height: 205px;
  }
  .swiper_phone1 .swiper-slide img {
    width: 300px;
    height: 165px;
  }
  .swiper_phone2 {
    width: 300px;
    height: 205px;
    margin-top: 20px;
  }
  .swiper_phone2 .swiper-slide {
    width: 300px;
    height: 205px;
  }
  .swiper_phone2 .swiper-slide div {
    width: 300px;
    height: 165px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cmp-detail.vue